<template>
  <div class="w-full flex flex-col">
    <div class="flex flex-row justify-between items-center gap-2">
      <div class="flex flex-row items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <g clip-path="url(#clip0_848_24403)">
            <path
              d="M8.48228 13.9823L3.48314 11.4985V7.05422L0.482422 5.58541L8.48228 1.63281L16.4821 5.58541V11.3158H15.4167V6.10233L13.4814 7.05422V11.4985L8.48228 13.9823ZM8.48228 8.35133L14.0268 5.58541L8.48228 2.81949L2.93774 5.58541L8.48228 8.35133ZM8.48228 12.7879L12.416 10.821V7.58691L8.48228 9.53658L4.54853 7.58691V10.821L8.48228 12.7879Z"
              fill="#696969" />
          </g>
          <defs>
            <clipPath id="clip0_848_24403">
              <rect width="16" height="16" fill="white" transform="translate(0.482422)" />
            </clipPath>
          </defs>
        </svg>
        <h4 class="nxp-review-title">Formação</h4>
      </div>

      <button class="nxp-review-title-action" type="button" @click="navigateToSelectedStep">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <path
            d="M4.54 15.4993H5.46625L13.6633 7.30227L12.7371 6.37602L4.54 14.5731V15.4993ZM3.45667 16.5827V14.1164L13.8237 3.73331C13.9358 3.61886 14.0565 3.5374 14.1856 3.48893C14.3148 3.44032 14.4501 3.41602 14.5917 3.41602C14.7333 3.41602 14.8685 3.43872 14.9973 3.48414C15.1262 3.52956 15.251 3.60997 15.3717 3.72539L16.306 4.65164C16.4215 4.77234 16.5032 4.89734 16.5512 5.02664C16.5993 5.15595 16.6233 5.28907 16.6233 5.42602C16.6233 5.57199 16.5981 5.71129 16.5475 5.84393C16.4968 5.97657 16.4163 6.09782 16.306 6.20768L5.92292 16.5827H3.45667ZM13.1921 6.84727L12.7371 6.37602L13.6633 7.30227L13.1921 6.84727Z"
            fill="#4F4F4F" />
        </svg>
        Editar
      </button>
    </div>
    <hr class="custom-hr my-2 mb-4" />


    <div v-if="show()" class="flex flex-col px-6">
      <div class="flex flex-col space-y-1 py-4" v-for="(formation, index) in formations" :key="`step-${index}`">
        <div class="nxp-review-experiencies-title" v-if="
          formation.grade != null ||
          (formation.grade != undefined && formation.institute != null) ||
          formation.institute != undefined
        ">
          {{ formation.grade.concat(` - ${formation.institute}`) }}
        </div>
        <div class="nxp-review-experiencies-subtitle" v-if="
          formation.from_date != null ||
          (formation.from_date != undefined && formation.to_date != null) ||
          (formation_to_date != undefined && formation.period != null) ||
          formation.period != undefined
        ">
          {{
            (formation.from_date) ?
              formation.from_date
                .concat(` até ${formation.to_date}`)
                .concat(` (${formation.period})`)
              :
              (
                ((formation.from_date === null || formation.from_date === undefined) && formation.to_date)
                  ? 'Início Não Informado - ' + formation.to_date
                  : formation.from_date + '- Não Informado')
          }}
        </div>
        <div class="nxp-review-experiencies-description" v-if="
          formation.scholarity != null ||
          (formation.scholarity != undefined && formation.level != null) ||
          formation.level != undefined
        ">
          {{ formation.scholarity.concat(` - ${formation.level}`) }}
        </div>
        <div v-if="formations.length > (index + 1)" class="flex w-full h-4"></div>
        <hr v-if="formations.length > (index + 1)" class="custom-hr" />
      </div>
    </div>

    <div v-else class="w-full flex flex-col items-center justify-center space-y-4 py-8">
      <p class="nxp-review-no-data-text">
        Nenhuma formação foi encontrada, <br />adicione para mostrar seu percurso educacional
      </p>
      <button class="nxp-review-no-data-btn" type="button" @click="navigateToSelectedStep">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <path
            d="M8.22616 8.75597H2.58252V7.24325H8.22616V1.59961H9.73888V7.24325H15.3825V8.75597H9.73888V14.3996H8.22616V8.75597Z"
            fill="#4F4F4F" />
        </svg>
        Adicionar Formação
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import { formatDistanceStrict } from 'date-fns'
// import ptBR from 'date-fns/locale/pt-BR'
import EmptyDetailCard from "@/components/dashboard/profile-detail/EmptyDetailCard";

export default {
  name: "simple-formation",
  props: {
    notFilled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("formation", ["formations"]),
    ...mapState("company", ["company"]),

    color() {
      return this.company.base_hexcolor || "#1551b1";
    },
  },
  methods: {
    ...mapActions("step", ["updateCurrentStep"]),
    // periodComputed({ from_date, to_date }) {
    //     const splitFrom = '01/'.concat(from_date).split('/')
    //     const splitTo = '01/'.concat(to_date).split('/')

    //     const from = new Date(splitFrom[2], splitFrom[1] -1, splitFrom[0])
    //     const to = new Date(splitTo[2], splitTo[1] -1, splitTo[0])

    //     return formatDistanceStrict(from, to, { locale: ptBR, addSuffix: true })
    // },
    navigateToSelectedStep() {
      this.updateCurrentStep({ order: 2 });
      this.$router.push({ name: "step-formation" });
    },

    show() {
      return this.formations.length > 0;
    },
  },
  components: { EmptyDetailCard },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/resume/simple.scss";
</style>
